import * as React from 'react';
import { useFiltersContext } from '../contexts/filters';

interface IProps {
	foundPosts: number;
}

const ResultCount = ({ foundPosts }: IProps) => {
	const { clearFilters, selectedTax, initSelectedTax, searchQuery } = useFiltersContext();

	const isActive =
		Object.values(selectedTax).length > 0 ||
		selectedTax !== initSelectedTax ||
		searchQuery !== '';

	const handleOnClick = () => {
		if (clearFilters) {
			clearFilters();
		}
	};

	if (foundPosts) {
		return (
			<div className="pfa-result-count" role="status" aria-live="polite" aria-atomic="true">
				Showing {foundPosts} {1 === foundPosts ? 'Result' : 'Results'}
				<button
					className={`pfa-result-count__clear pfa-result-count__clear ${isActive ? 'pfa-result-count__clear--active' : ''}`}
					onClick={handleOnClick}
				>
					Clear Filters
				</button>
			</div>
		);
	}

	return <></>;
};

ResultCount.displayName = 'ResultCount';

export default ResultCount;
